import './src/styles/global.scss';
import "aos/dist/aos.css";

